import styled from 'styled-components'

export const DownloadContainer = styled.div`
    width: 80%;
    display: inline-block;
    padding: 0 10%;
`